import { render, staticRenderFns } from "./CascoAjanlatBase.vue?vue&type=template&id=810a80aa&"
import script from "./CascoAjanlatBase.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports